import React from "react";
import StepHeading from "../../common/stepHeading/StepHeading";
import DialogConfirmButtons from "../../common/dialogConfirmButtons/DialogConfirmButtons";
import SuccessMessage from "../../messages/SuccessMessage";

const EmailChangedStep = ({ busy, newEmail, onCompleted }) => {
  const onDoneClicked = () => {
    onCompleted();
  };

  const buttons = (
    <DialogConfirmButtons
      appearBusy={busy}
      confirmBtnLabel="Done"
      confirmBtnAutoFocus={true}
      onConfirm={onDoneClicked}
      omitCancelBtn={true}
    />
  );

  return (
    <div id="email-changed-step">
      <div className="change-email-step-body">
        <StepHeading label="New email address" value={newEmail} />
        <SuccessMessage
          className="email-changed-success-message"
          message={`User's email address has been changed to ${newEmail}.`}
        />
      </div>
      {buttons}
    </div>
  );
};

export default EmailChangedStep;
